
const digest = '4f4396c4206bafcd869c9b470209a7a45fb32570594418c429814ecc72662acb';
const classes = {"wrapper":"_wrapper_1gz1n_1","column":"_column_1gz1n_13","item":"_item_1gz1n_24","empty":"_empty_1gz1n_24","pus":"_pus_1gz1n_24","bleeding":"_bleeding_1gz1n_24","plaque":"_plaque_1gz1n_24"};
const css = `._wrapper_1gz1n_1 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 2px;
}
@media (max-width: 1200px) {
  ._wrapper_1gz1n_1 {
    gap: 1px;
  }
}

._column_1gz1n_13 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
@media (max-width: 1200px) {
  ._column_1gz1n_13 {
    gap: 1px;
  }
}

._item_1gz1n_24, ._empty_1gz1n_24, ._pus_1gz1n_24, ._bleeding_1gz1n_24, ._plaque_1gz1n_24 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
@media (max-width: 1400px) {
  ._item_1gz1n_24, ._empty_1gz1n_24, ._pus_1gz1n_24, ._bleeding_1gz1n_24, ._plaque_1gz1n_24 {
    width: 7px;
    height: 7px;
  }
}
@media (max-width: 1200px) {
  ._item_1gz1n_24, ._empty_1gz1n_24, ._pus_1gz1n_24, ._bleeding_1gz1n_24, ._plaque_1gz1n_24 {
    width: 5px;
    height: 5px;
  }
}

._plaque_1gz1n_24 {
  background-color: #4a90e2;
}

._bleeding_1gz1n_24 {
  background-color: #d0021b;
}

._pus_1gz1n_24 {
  background-color: #f8e71c;
}

._empty_1gz1n_24 {
  border: 1px solid #4d5565;
}
@media (max-width: 1200px) {
  ._empty_1gz1n_24 {
    border-width: 0.5px;
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  